// assets/nd-cart-edit-reload-redirect.js
// ND Cart Self-Built Modify Button
// - Do NOT rely on Optis native cart edit button
// - Works for normal newly-added configurable items and history-reloaded items
// - Opens product option page with selected properties saved in sessionStorage
// - After modified item is added, remove old cart line via ND:PENDING_REPLACE

(function () {
  if (window.__ND_CART_SELF_MODIFY_V1__) return;
  window.__ND_CART_SELF_MODIFY_V1__ = true;

  var TAG = "[ND][CART_SELF_MODIFY_V1]";

  function log() {
    try { console.log.apply(console, [TAG].concat([].slice.call(arguments))); } catch (e) {}
  }

  function warn() {
    try { console.warn.apply(console, [TAG].concat([].slice.call(arguments))); } catch (e) {}
  }

  function isCartPage() {
    try {
      return (location.pathname || "").toLowerCase().indexOf("/cart") === 0;
    } catch (e) {
      return false;
    }
  }

  if (!isCartPage()) return;

  function injectStyle() {
    try {
      if (document.getElementById("nd-cart-self-modify-style")) return;

      var s = document.createElement("style");
      s.id = "nd-cart-self-modify-style";
      s.textContent = `
        .nd-modify-btn{
          display:inline-flex !important;
          align-items:center !important;
          justify-content:center !important;
          padding:8px 14px !important;
          border-radius:6px !important;
          background:#111 !important;
          color:#fff !important;
          border:0 !important;
          cursor:pointer !important;
          font-size:13px !important;
          line-height:1 !important;
          text-decoration:underline !important;
          text-underline-offset:2px !important;
          -webkit-appearance:none !important;
          appearance:none !important;
          margin-right:8px !important;
        }
        .nd-modify-btn:hover{
          opacity:.92 !important;
        }
      `;
      document.head.appendChild(s);
    } catch (e) {}
  }

  injectStyle();

  function safeJsonParse(s) {
    try { return JSON.parse(s); } catch (e) { return null; }
  }

  function cssEsc(v) {
    try {
      return window.CSS && CSS.escape
        ? CSS.escape(String(v))
        : String(v).replace(/"/g, '\\"');
    } catch (e) {
      return String(v || "");
    }
  }

  function buildReturnTo() {
    try {
      return location.pathname + location.search;
    } catch (e) {
      return "/cart";
    }
  }

  function ssKey(lineKey) {
    return "ND:RELOAD_EDIT_PAYLOAD:" + String(lineKey || "");
  }

  function pendingKey() {
    return "ND:PENDING_REPLACE";
  }

  function getText(el) {
    try {
      return String((el && (el.textContent || el.value || el.innerText)) || "").trim();
    } catch (e) {
      return "";
    }
  }

  // 判斷是不是有 OPTIS/BSS 選配資料的 cart item
  // 新加入產品、reload 回來產品都會通過
  function isConfigurableCartItem(item) {
    try {
      var p = item && item.properties ? item.properties : {};

      if (!p || typeof p !== "object") return false;

      if (String(p._nd_reload) === "1") return true;

      if (p._bssCustomAttributes) return true;
      if (p._bss_po_addons) return true;
      if (p._bssPrice) return true;
      if (p._bssVariants) return true;

      // 保險：只要有 _bss 開頭的 hidden property，也視為可修改商品
      var keys = Object.keys(p);
      for (var i = 0; i < keys.length; i++) {
        if (String(keys[i]).indexOf("_bss") === 0) return true;
      }

      return false;
    } catch (e) {
      return false;
    }
  }

  // 放棄 OPTIS 原生 cart edit button：有出現就隱藏
  function hideNativeOptisEditButtons() {
    try {
      document.querySelectorAll("[bss-po-line-item-key]").forEach(function (el) {
        el.style.display = "none";
        el.setAttribute("aria-hidden", "true");
      });
    } catch (e) {}
  }

  function findDuplicateLinkByIndex(idx) {
    try {
      var all = [].slice.call(
        document.querySelectorAll("a, button, input[type='button'], input[type='submit']")
      );

      var dupes = all.filter(function (el) {
        return /^Duplicate$/i.test(getText(el));
      });

      return dupes[idx] || dupes[0] || null;
    } catch (e) {
      return null;
    }
  }

  function findCartItemArea(idx) {
    try {
      return (
        document.querySelector("#CartItem-" + (idx + 1)) ||
        document.querySelector("#cart-item-" + (idx + 1)) ||
        document.querySelectorAll(".cart-item")[idx] ||
        document.querySelectorAll("tr.cart-item")[idx] ||
        document.querySelector('form[action="/cart"]') ||
        document.querySelector("main") ||
        document.body
      );
    } catch (e) {
      return document.body;
    }
  }

  function openModifyPage(item) {
    try {
      var lineKey = item && item.key ? String(item.key) : "";

      if (!lineKey) {
        warn("Missing lineKey, cannot modify.", item);
        return;
      }

      var payload = {
        mode: "modify",
        lineKey: lineKey,
        oldLineKey: lineKey,
        ndLineKey: lineKey,
        variant_id: item.variant_id,
        product_id: item.product_id,
        quantity: item.quantity || 1,
        properties: item.properties || {},
        title: item.product_title || item.title || "",
        url: item.url || "",
        return_to: buildReturnTo(),
        ts: Date.now()
      };

      try {
        sessionStorage.setItem(ssKey(lineKey), JSON.stringify(payload));
        sessionStorage.setItem("ND:MODIFY_PAYLOAD:" + lineKey, JSON.stringify(payload));
        sessionStorage.setItem("ND:LAST_MODIFY_LINE_KEY", lineKey);
      } catch (err2) {}

      var baseUrl = item.url || "";

      if (!baseUrl) {
        warn("Missing item.url, cannot open modify page.", item);
        return;
      }

      var u = baseUrl;
      var hasQ = u.indexOf("?") >= 0;

      u += (hasQ ? "&" : "?") + "view=nd_optis_embed";
      u += "&ndReloadEdit=1";
      u += "&ndModify=1";
      u += "&ndLineKey=" + encodeURIComponent(lineKey);

      if (item.variant_id) {
        u += "&variant=" + encodeURIComponent(String(item.variant_id));
      }

      u += "&return_to=" + encodeURIComponent(buildReturnTo());
      u += "&ndTs=" + Date.now();

      try {
        var W = 980;
        var H = 780;
        var left = Math.max(0, Math.round((screen.width - W) / 2));
        var top = Math.max(0, Math.round((screen.height - H) / 2));

        var features = [
          "width=" + W,
          "height=" + H,
          "left=" + left,
          "top=" + top,
          "resizable=yes",
          "scrollbars=yes",
          "toolbar=no",
          "menubar=no",
          "location=no",
          "status=no"
        ].join(",");

        log("modify page ->", u);

        var pop = window.open(u, "ND_OPTIS_MODIFY", features);

        if (!pop) {
          warn("popup blocked, fallback redirect");
          location.href = u;
          return;
        }

        try { pop.focus(); } catch (e3) {}
      } catch (e2) {
        warn("popup open failed, fallback redirect", e2);
        location.href = u;
      }
    } catch (err) {
      warn("openModifyPage failed", err);
    }
  }

  function ensureModifyButton(item, idx) {
    try {
      var lineKey = item && item.key ? String(item.key) : "";
      if (!lineKey) return false;

      var existing = document.querySelector(
        '[data-nd-modify-line-key="' + cssEsc(lineKey) + '"]'
      );

      if (existing) return false;

      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "nd-modify-btn";
      btn.textContent = "Modify";
      btn.setAttribute("data-nd-modify-line-key", lineKey);

      btn.addEventListener("click", function (e) {
        try {
          e.preventDefault();
          e.stopPropagation();
        } catch (err) {}

        openModifyPage(item);
      }, true);

      var dup = findDuplicateLinkByIndex(idx);

      if (dup && dup.parentNode) {
        dup.parentNode.insertBefore(btn, dup);
      } else {
        var area = findCartItemArea(idx);
        area.appendChild(btn);
      }

      return true;
    } catch (e) {
      warn("ensureModifyButton failed", e);
      return false;
    }
  }

  async function runOnce() {
    try {
      hideNativeOptisEditButtons();

      var res = await fetch("/cart.js", {
        credentials: "same-origin",
        cache: "no-store"
      });

      if (!res.ok) return;

      var cart = await res.json();
      var items = cart && Array.isArray(cart.items) ? cart.items : [];

      var changed = 0;

      items.forEach(function (it, idx) {
        if (!isConfigurableCartItem(it)) return;

        if (ensureModifyButton(it, idx)) {
          changed++;
        }
      });

      if (changed) log("self-built Modify buttons:", changed);
    } catch (e) {
      warn("runOnce failed", e);
    }
  }

  // -----------------------------
  // FINALIZE: after modified item added, remove old cart line
  // -----------------------------

  var ND_CART_SECTION_IDS = [
    "template-26401165508930__main-cart-items",
    "template-26401165508930__main-cart-footer"
  ];

  function ndBeginVeil() {
    if (document.getElementById("nd-replace-veil")) return;

    try {
      var s = document.createElement("style");
      s.id = "nd-replace-veil-style";
      s.textContent =
        "#nd-replace-veil{position:fixed;inset:0;z-index:999999;background:rgba(255,255,255,0.01);cursor:progress}" +
        ".nd-replace-lock *{pointer-events:none!important}" +
        ".nd-replace-dim{opacity:.25!important;transition:opacity .12s ease}";
      document.head.appendChild(s);

      var v = document.createElement("div");
      v.id = "nd-replace-veil";
      document.body.appendChild(v);

      (document.querySelector('form[action="/cart"]') || document.querySelector("main") || document.body)
        .classList.add("nd-replace-dim");

      document.documentElement.classList.add("nd-replace-lock");

      try { document.body.style.overflow = "hidden"; } catch (e) {}
    } catch (e) {}
  }

  function ndEndVeil() {
    try {
      var v = document.getElementById("nd-replace-veil");
      if (v) v.remove();

      var s = document.getElementById("nd-replace-veil-style");
      if (s) s.remove();

      (document.querySelector('form[action="/cart"]') || document.querySelector("main") || document.body)
        .classList.remove("nd-replace-dim");

      document.documentElement.classList.remove("nd-replace-lock");

      try { document.body.style.overflow = ""; } catch (e) {}
    } catch (e) {}
  }

  async function ndRenderCartSectionsOnce(sectionIds) {
    var url = "/?sections=" + encodeURIComponent(sectionIds.join(","));

    var res = await fetch(url, {
      credentials: "same-origin",
      cache: "no-store"
    });

    if (!res.ok) {
      throw new Error("sections fetch failed: " + res.status);
    }

    var data = await res.json();
    var replaced = 0;

    sectionIds.forEach(function (id) {
      var html = data[id];
      if (!html) return;

      var host = document.getElementById("shopify-section-" + id);
      if (!host) return;

      host.innerHTML = html;
      replaced++;
    });

    if (!replaced) {
      warn("No cart sections replaced. Section ids may have changed.");
    }
  }

  async function finalizeReplaceIfNeeded() {
    var pending = null;

    try {
      pending = safeJsonParse(sessionStorage.getItem(pendingKey()) || "");
    } catch (e) {
      pending = null;
    }

    var oldKey = pending && (
      pending.oldLineKey ||
      pending.ndLineKey ||
      pending.lineKey
    );

    if (!pending || !oldKey) return;

    if (pending.ts && Date.now() - pending.ts > 2 * 60 * 1000) {
      try { sessionStorage.removeItem(pendingKey()); } catch (e) {}
      return;
    }

    if (window.__ND_FINALIZE_RUNNING__) return;
    window.__ND_FINALIZE_RUNNING__ = true;

    ndBeginVeil();

    try {
      var res = await fetch("/cart.js", {
        credentials: "same-origin",
        cache: "no-store"
      });

      if (!res.ok) return;

      var cart = await res.json();
      var items = cart && Array.isArray(cart.items) ? cart.items : [];

      var idx = -1;

      for (var i = 0; i < items.length; i++) {
        if (String(items[i].key) === String(oldKey)) {
          idx = i;
          break;
        }
      }

      if (idx < 0) {
        try { sessionStorage.removeItem(pendingKey()); } catch (e) {}
        return;
      }

      var line = idx + 1;

      log("finalize: removing old line", {
        line: line,
        oldKey: oldKey
      });

      var r2 = await fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          line: line,
          quantity: 0
        })
      });

      if (!r2.ok) {
        throw new Error("cart/change failed");
      }

      try { sessionStorage.removeItem(pendingKey()); } catch (e) {}

      await ndRenderCartSectionsOnce(ND_CART_SECTION_IDS);

      try { await runOnce(); } catch (e) {}
      setTimeout(runOnce, 300);

      requestAnimationFrame(function () {
        ndEndVeil();
      });
    } catch (err) {
      warn("finalizeReplace failed", err);

      requestAnimationFrame(function () {
        ndEndVeil();
      });
    } finally {
      setTimeout(function () {
        window.__ND_FINALIZE_RUNNING__ = false;
      }, 1200);
    }
  }

  try {
    var mo = new MutationObserver(function () {
      if (window.__ndSelfModifyDebounce) return;

      window.__ndSelfModifyDebounce = true;

      setTimeout(function () {
        window.__ndSelfModifyDebounce = false;
        runOnce();
      }, 250);
    });

    mo.observe(document.body, {
      childList: true,
      subtree: true
    });
  } catch (e) {}

  try { finalizeReplaceIfNeeded(); } catch (e) {}

  setTimeout(runOnce, 0);
  setTimeout(runOnce, 500);
  setTimeout(runOnce, 1500);
  setTimeout(runOnce, 3000);

  log("ready");
})();